import React, { useEffect, useState } from 'react';
import { VisualizationPanel } from 'survey-analytics';
import { Model } from 'survey-core';
import 'jspdf-autotable';
import {
  formatedTemplate,
  QUESTION_TYPES_DASHBOARD,
} from '../../../containers/change-insights/utils/index.jsx';
import Empty from '../../Empty.jsx';
import { surveyWaitingContent } from '../../EmptyStates.jsx';
import DownArrowIcon from '../../icons/DownArrowIcon.jsx';
import RightArrowIcon from '../../icons/RightArrowIcon.jsx';
import SubHeader from '../../SubHeader.jsx';
import ChangeInsightsReportTable from './ChangeInsightsReportTable.jsx';

const vizPanelOptions = {
  allowHideQuestions: false,
  allowDragDrop: false,
};

const orderArrayBy = (order, inputArray) => {
  const orderMap = {};
  order.forEach((key, index) => {
    orderMap[key] = index;
  });

  return inputArray.sort((a, b) => {
    const orderA = orderMap[a.name];
    const orderB = orderMap[b.name];

    if (orderA === undefined && orderB === undefined) {
      return 0;
    }
    if (orderA === undefined) {
      return 1;
    }
    if (orderB === undefined) {
      return -1;
    }

    return orderA - orderB;
  });
};

const ChangeInsightsReport = ({
  surveyResponses,
  surveyJson,
  dashboardSettings,
  changeInsightSettings,
}) => {
  const [survey, setSurvey] = useState(null);
  const [vizPanel, setVizPanel] = useState(null);
  const [questionsSetting, setQuestionSetting] = useState([]);

  const [isShowOpenEndedView, setIsShowOpenEndedView] = useState(false);

  useEffect(() => {
    if (survey) {
      const questions = survey.getAllQuestions().filter((question) => {
        const questionSetting = questionsSetting.find(
          (q) => q.name === question.jsonObj.name
        );
        if (questionSetting?.dashboardShow) {
          return question;
        }
      });

      let order = [];
      if (dashboardSettings.length > 0) {
        order = dashboardSettings.map(
          (item) => item.dashboardShow && item?.name
        );
      }

      if (!dashboardSettings.length && questionsSetting) {
        order = questionsSetting.map((item) => item.name);
      }
      const sortedQuestions = orderArrayBy(order, questions).filter((item) =>
        order.includes(item.jsonObj.name)
      );

      const vizualPanel = new VisualizationPanel(
        dashboardSettings ? sortedQuestions : questions,
        surveyResponses,
        vizPanelOptions
      );
      vizualPanel.visualizers.forEach((v, index) => {
        if (
          vizualPanel.visualizers[index].question.jsonObj.type === 'dropdown'
        ) {
          vizualPanel.visualizers[index]._chartType = 'doughnut';
        }

        if (vizualPanel.visualizers[index]._type === 'matrix') {
          vizualPanel.visualizers[index]._chartType = 'stackedbar';
          vizualPanel.visualizers[index].chartTypes = ['stackedbar'];
        }
      });

      setVizPanel(vizualPanel);
    }
  }, [survey, dashboardSettings, surveyResponses, questionsSetting]);

  useEffect(() => {
    if (vizPanel && surveyResponses?.length) {
      vizPanel.render(document.getElementById('surveyVizPanel'));

      return () => {
        const surveyVizPanel = document.getElementById('surveyVizPanel');
        if (surveyVizPanel) {
          surveyVizPanel.innerText = '';
        }
      };
    }
  }, [vizPanel, surveyResponses, dashboardSettings]);

  useEffect(() => {
    if (!survey) {
      const survey = new Model(surveyJson);
      setSurvey(survey);
    }
  }, [surveyJson]);

  useEffect(() => {
    if (changeInsightSettings) {
      const parsedSurveyJson = formatedTemplate(changeInsightSettings);
      if (parsedSurveyJson) {
        const surveyModel = new Model(parsedSurveyJson);
        const defaultQuestions = surveyModel
          .getAllQuestions()
          .filter((question) =>
            QUESTION_TYPES_DASHBOARD.includes(question.jsonObj.type)
          )
          .map((question, index) => ({
            id: question.jsonObj.title,
            name: question.jsonObj.name,
            title: question.jsonObj.title,
            priority: index,
            dashboardShow: true,
          }));
        setQuestionSetting(defaultQuestions);
      }
    }
  }, [changeInsightSettings]);

  return (
    <React.Fragment>
      <SubHeader medium>
        <h2>Feedback Results Dashboard</h2>
      </SubHeader>
      {!surveyResponses.length ? (
        <Empty
          className="component-bg-white component-border-bottom"
          content={surveyWaitingContent}
        />
      ) : (
        <React.Fragment>
          <div className="component component-bg-white p-b-0">
            {vizPanel && !vizPanel.getElements().length ? (
              <div className="center-block text-center">
                <h2 className="text-primary">No Results</h2>
                <p className="text-muted m-b-24">
                  There are no questions available to be displayed on the
                  dashboard. Please navigate to open-ended responses to view the
                  survey results.
                </p>
              </div>
            ) : null}
            <div
              id="surveyVizPanel"
              style={
                vizPanel && !vizPanel.getElements().length ? { height: 0 } : {}
              }
            />
          </div>
          {survey &&
          survey
            .getAllQuestions()
            .filter(
              (r) => r.jsonObj.type === 'text' || r.jsonObj.type === 'comment'
            ).length ? (
            <React.Fragment>
              <SubHeader
                className="flex"
                onClick={() => setIsShowOpenEndedView(!isShowOpenEndedView)}
                medium
              >
                {isShowOpenEndedView ? <DownArrowIcon /> : <RightArrowIcon />}
                <h2 className="m-l-8">Open-Ended Responses</h2>
              </SubHeader>
              {isShowOpenEndedView ? (
                <ChangeInsightsReportTable
                  surveyResponses={surveyResponses}
                  surveyJson={surveyJson}
                />
              ) : null}
            </React.Fragment>
          ) : null}
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default ChangeInsightsReport;
